import BillingsOrderRelatedRailyTaxiResponse, {
  BillingsOrderRelatedRailyTaxiResponseData,
  BillingsOrderRelatedRailyTaxiResponseDataCargoOrder,
  BillingsOrderRelatedRailyTaxiResponseDataContract,
  BillingsOrderRelatedRailyTaxiResponseDataContractTaxiCorporation,
} from "../../../../../api/raily/billings/order/related/raily-taxi/billings-order-related-raily-taxi.response";
import BillingsOrderRelatedRailyTaxi, {
  BillingsOrderRelatedRailyTaxiCargoOrder,
  BillingsOrderRelatedRailyTaxiContract,
  BillingsOrderRelatedRailyTaxiContractTaxiCorporation,
} from "./billings-order-related-raily-taxi";

const createCargoOrder = (
  cargoOrder: BillingsOrderRelatedRailyTaxiResponseDataCargoOrder,
): BillingsOrderRelatedRailyTaxiCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    id: cargoOrder.id,
  };
};

const createTaxiCorporation = (
  cargoCompany: BillingsOrderRelatedRailyTaxiResponseDataContractTaxiCorporation,
): BillingsOrderRelatedRailyTaxiContractTaxiCorporation => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createContract = (
  contract: BillingsOrderRelatedRailyTaxiResponseDataContract,
): BillingsOrderRelatedRailyTaxiContract => {
  return {
    distanceRate: contract.distanceRate,
    model: contract.model,
    taxiCorporation: createTaxiCorporation(contract.taxiCorporation),
  };
};

const createDataItem = (
  item: BillingsOrderRelatedRailyTaxiResponseData,
): BillingsOrderRelatedRailyTaxi => {
  return {
    bonus: item.bonus,
    cargoOrder: createCargoOrder(item.cargoOrder),
    contract: createContract(item.contract),
    date: item.date,
    distance: item.distance,
    distanceAmount: item.distanceAmount,
    haltingAmount: item.haltingAmount,
    highwayCharge: item.highwayCharge,
    penalty: item.penalty,
    totalAmount: item.totalAmount,
    baseAmount: item.baseAmount,
    draft: item.draft,
  };
};

const createData = (
  data: BillingsOrderRelatedRailyTaxiResponseData[],
): BillingsOrderRelatedRailyTaxi[] => {
  return data.map(createDataItem);
};

const create = (
  response: BillingsOrderRelatedRailyTaxiResponse,
): BillingsOrderRelatedRailyTaxi[] => {
  return createData(response.data);
};

const billingsOrderRelatedRailyTaxiFactory = {
  create,
};

export default billingsOrderRelatedRailyTaxiFactory;
